export const ContactUsMap = {
  GET_ALL_CONTACT_START: "GET_ALL_CONTACT_START",
  GET_ALL_CONTACT_SUCCESS: "GET_ALL_CONTACT_SUCCESS",
  GET_ALL_CONTACT_ERROR: "GET_ALL_CONTACT_ERROR",
  SEARCH_TEXT_CHANGE: "SEARCH_TEXT_CHANGE",
  SET_CONTACT_BATCH_NUMBER: "SET_CONTACT_BATCH_NUMBER",
  GET_CONTACT_START: "GET_CONTACT_START",
  GET_CONTACT_SUCCESS: "GET_CONTACT_SUCCESS",
  GET_CONTACT_ERROR: "GET_CONTACT_ERROR",
  SELECT_CONTACT_DETAILS: "SELECT_CONTACT_DETAILS",
  PAGE_TYPE_CHANGE: "PAGE_TYPE_CHANGE",
  GET_PAGE_NAME_LIST_SUCCESS: "GET_PAGE_NAME_LIST_SUCCESS",
  SET_AUDIO_TYPE: "SET_AUDIO_TYPE",
  SET_LEAD_TYPE: "SET_LEAD_TYPE",
  SET_CALL_OUTCOME_FILTER: "CONTACT_US_SET_CALL_OUTCOME_FILTER",
  SET_LIMIT: "SET_LIMIT",
  UPDATE_LEAD_TYPE_IN_LIST: "CONTACT_US_UPDATE_LEAD_TYPE_IN_LIST",
};

export const contactUsAction = {
  getAllContactStart: (data) => ({
    type: ContactUsMap.GET_ALL_CONTACT_START,
    payload: data,
  }),
  getAllContactSuccess: (data) => ({
    type: ContactUsMap.GET_ALL_CONTACT_SUCCESS,
    payload: data,
  }),
  getAllContactError: (errors) => ({
    type: ContactUsMap.GET_ALL_CONTACT_ERROR,
    payload: { errors },
  }),
  refreshContactList: () => ({ type: ContactUsMap.REFRESH_CONTACT_LIST }),
  searchTextChange: (data) => ({
    type: ContactUsMap.SEARCH_TEXT_CHANGE,
    payload: data,
  }),
  setContactBatchNumber: (data) => ({
    type: ContactUsMap.SET_CONTACT_BATCH_NUMBER,
    payload: data,
  }),
  getContactStart: (data) => ({
    type: ContactUsMap.GET_CONTACT_START,
    payload: data,
  }),
  getContactSuccess: (data) => ({
    type: ContactUsMap.GET_CONTACT_SUCCESS,
    payload: data,
  }),
  getContactError: (errors) => ({
    type: ContactUsMap.GET_CONTACT_ERROR,
    payload: { errors },
  }),
  getContactPageNameListSuccess: (data) => ({
    type: ContactUsMap.GET_PAGE_NAME_LIST_SUCCESS,
    payload: data,
  }),
  setAudioType: (data) => ({
    type: ContactUsMap.SET_AUDIO_TYPE,
    payload: data,
  }),
  setLeadType: (data) => ({
    type: ContactUsMap.SET_LEAD_TYPE,
    payload: data,
  }),
  setCallOutcomeFilter: (callOutcome) => ({
    type: ContactUsMap.SET_CALL_OUTCOME_FILTER,
    payload: callOutcome,
  }),
  setLimit: (data) => ({
    type: ContactUsMap.SET_LIMIT,
    payload: data,
  }),
  // Patch a single record's leadType inside ContactList.records — used by the
  // listing page dropdown so it doesn't clobber the whole list (unlike
  // getContactSuccess, which replaces ContactList with a single record, meant
  // for the detail/view page).
  updateLeadTypeInList: (id, leadType) => ({
    type: ContactUsMap.UPDATE_LEAD_TYPE_IN_LIST,
    payload: { id, leadType },
  }),
};
